import { Injectable } from '@angular/core';
import { DataService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ReporteService {

    constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

    private listarAccesoReporteUrl: string = 'reporte/listarAccesoReporte';

    listarAccesoReporte(filtro: string, idNivelAcceso: number, idEntidad: number, idRol: number): any {
        let parameters = new HttpParams();
        parameters = parameters.append("pFiltro", String(filtro));
        parameters = parameters.append("idEmpresa", String(this.sessionInfo.getEmpresaID()));
        parameters = parameters.append("idNivelAcceso", String(idNivelAcceso));
        parameters = parameters.append("idEntidad", String(idEntidad));
        parameters = parameters.append("idRol", String(idRol));
        this.dataService._baseUri = environment.serviceCreditosUrl + this.listarAccesoReporteUrl;
        return this.dataService.execGetJson(parameters);
    }
}